<template>
  <div class="container" :class="{ fullscreen: isFullScreen }">
    <!-- <a :href="icons.file.link" target="_blank">
      <img :src="icons.file.img" :alt="icons.file.name" />
    </a> -->
    <figure>
      <img src="./assets/robocote4.png" alt="" v-if="chatbotImageFooter === 'robocote'" />
      <img src="./assets/yupin-footer.png" alt="" v-if="chatbotImageFooter === 'yupin'" />
    </figure>
  </div>
</template>

<script>
// import RobocoteIcon from './assets/robocote4.png'

export default {
  props: {
    // icons:{
    //   type: Object,
    //   required: false,
    //   default: function () {
    //     return {
    //       file:{
    //         img: RobocoteIcon,
    //         name: 'Robocote',
    //         link: 'https://robocote.com/',
    //       },
    //     }
    //   }
    // },
    chatbotImageFooter: {
      type: String
    },
  },
  computed: {
    isFullScreen () {
      return this.$store.getters.isFullScreen;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  width: 100%;

  figure {
    margin: 0;

    img {
      margin: 0;
    }
  }
}
img {
  margin: 3px 0;
}
</style>
